import { defineComponent as _defineComponent } from 'vue'
import LChip from '@/components/commons/LChip.vue';
import moment from 'moment/moment';
import {computed, onMounted, ref} from 'vue';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import DateUtils from '@/services/utils/DateUtils';
import FpTooltip from '@/components/fpComponents/FpTooltip.vue';
import {Moment} from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'LTimerPill',
  props: {
    endDate: null,
    iconTimerActive: null,
    iconTimerInactive: null,
    tooltipTitle: null,
    tooltipText: null,
    color: null,
    textColor: null,
    noOpacity: { type: Boolean }
  },
  emits: ["timerEnded"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'timerEnded'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  endDate: string | Moment | Date | Object;
  iconTimerActive: string;
  iconTimerInactive: string;
  tooltipTitle?: string;
  tooltipText?: string;
  color?: string;
  textColor?: string;
  noOpacity?: boolean;
}






const timer = ref<NodeJS.Timeout>();
const countdown = ref<string>('');
const isTimerActive = ref<boolean>(true);
const expiration = moment(props.endDate);

onMounted(() => {
  updateCountdown()
  timer.value = setInterval(() => {
    updateCountdown();
  }, 1000);
});

const updateCountdown = () => {
  const now = moment();
  const duration = moment.duration(expiration.diff(now));

  if (duration.asSeconds() <= 0) {
    countdown.value = '';
    isTimerActive.value = false;
    emits('timerEnded');
    clearInterval(timer.value);
  } else if (duration.asHours() < DateUtils.HOURS_IN_DAY) {
    const hours = String(duration.hours()).padStart(2, '0');
    const minutes = String(duration.minutes()).padStart(2, '0');
    const seconds = String(duration.seconds()).padStart(2, '0');
    countdown.value = `${hours}:${minutes}:${seconds}`;
  }
}

const timeRemaining = computed(() => {
  const diffHours = expiration.diff(moment(), 'hours');
  if (diffHours < DateUtils.HOURS_IN_DAY) {
    return countdown.value;
  } else {
    const diffDays = moment(props.endDate).diff(moment(), 'days');
    return `${diffDays} ${diffDays > 1 ? I18NGetter().useAttachmentBadge.DAYS : I18NGetter().useAttachmentBadge.DAY}`;
  }
})

return { __sfc: true,props, emits, timer, countdown, isTimerActive, expiration, updateCountdown, timeRemaining, LChip, FpTooltip }
}

})